<template>
	<dashboard-dropdown-section
		title="Offers Posted"
		type="practice-created-offers"
		:items-shown="5"
		:items="offers"
		event-name="load-practice-offers"
		@load-practice-offers="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'PracticeCreatedOffers',

	components: { DashboardDropdownSection },

	data: () => ({
		offers: [],
	}),

	methods: {
		...mapActions('offers', ['FetchFilteredOffers']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const offersResults = await this.FetchFilteredOffers({ startDate, endDate, offersType: 'practice-created-offers' });
			this.offers = offersResults.map(offer => ({ ...offer, event_start_date: offer.date }));
		},
	},
};
</script>
